import { FileReader, FileWriter } from '@/platform'
import FileName from '../../ComControl/FileName'

class BGMItem {
    public Name: string = '' // BGM名称
    public BitmapPath: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) // 个性图片路径
    public BgmPath: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) // BGM详细音乐文件路径
    public Message: string = '' // BGM介绍

    /**
     * @description: 重写ToSting方法()
     * @param {type}
     * @return:
     */
    ToString() {
        return this.Name
    }

    constructor(
        param?: { name: string; bgmPath: string; bitmapPath: string; msg: string } | FileReader
    ) {
        if (param && 'name' in param) {
            const { name, bgmPath, bitmapPath, msg } = param
            this.Name = name
            this.BgmPath = new FileName({ type: FileName.DEF_TYPE, name: bgmPath })
            this.BitmapPath = new FileName({ type: FileName.DEF_TYPE, name: bitmapPath })
            this.Message = msg
        } else if (param instanceof FileReader) {
            this.readBin(param as FileReader)
        } else {
            this.Name = ''
            this.BgmPath = new FileName({ type: FileName.DEF_TYPE, name: '' })
            this.BitmapPath = new FileName({ type: FileName.DEF_TYPE, name: '' })
            this.Message = ''
        }
    }

    readBin(reader: FileReader): void {
        // 与 cg_v3_data BGMItem @DataStrucrParse 顺序一致：Name → BitmapPath → BgmPath → Message
        this.Name = reader.readString()
        this.BitmapPath = new FileName(reader)
        this.BgmPath = new FileName(reader)
        this.Message = reader.readString()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        this.BitmapPath.writeBin(writer)
        this.BgmPath.writeBin(writer)
        writer.writeString(this.Message)
    }

    readVersionedOui(reader: FileReader): void {
        this.Name = reader.readString()
        this.BgmPath = new FileName(reader)
        this.BitmapPath = new FileName(reader)
        this.Message = reader.readString()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeString(this.Name)
        this.BgmPath.writeVersionedOui(writer)
        this.BitmapPath.writeVersionedOui(writer)
        writer.writeString(this.Message)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default BGMItem
